export default __webpack_public_path__ + "static/media/CALCULO-DE-VOLUME.18097bc6.svg";